import { Button, Create, useDisclosure } from "@pankod/refine-chakra-ui";
import { IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
  } from '@chakra-ui/react'
import { useMemo, useState } from "react";
import { MainSection, TemplateAccordian, useApiSdk, validateTemplateInputs } from "ui-core";
import {useContractSettings } from "ui-rto";
import React from "react";

let contentDefinitionMode: 'editor' | 'upload' = 'upload';

export const TemplateCreate: React.FC<IResourceComponentsProps>  = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [templateTitle, setTemplateTitle] = useState("");
    const [templateState, setTemplateStates] = useState("");
    const [templateCompanies, setTemplateCompanies] = useState("");
    const [templateContents, setTemplateContents] = useState("");
    const [templateVariables, setTemplateVariables] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const { isOpen, onOpen, onClose } = useDisclosure();
    const okRef = React.useRef();

    const dataRef = React.useRef<any>({});
    const settingsDataRef = React.useRef<any>({});
    const settingsQuery = useContractSettings();

    const titleChange = (arg: string) => {
        setTemplateTitle(arg);
    }

    const statesChange = (arg: string) => {
        setTemplateStates(arg);
    }

    const companiesChange = (arg: string) => {
        setTemplateCompanies(arg);
    }

    const contentChange = (arg: string) => {
        setTemplateContents(arg);
    }

    const variablesChange = (arg: string) => {
        setTemplateVariables(arg);
    }

    const navMethods = useNavigation();
    const sdk = useApiSdk();

    async function doCreateTemplate() {  
        try {
            const result = await sdk.CreateContractTemplate ({
                input: {
                    title: templateTitle,
                    states: templateState,
                    companies: templateCompanies,
                    content: templateContents,
                    variables: templateVariables,
                    settings: settingsDataRef.current,
                    contentFileId: dataRef.current?.fileId || '',
                    productTypes: settingsDataRef.current?.productTypes || [],
                }
            });
            navMethods.list("contractTemplates");
        }catch(error) {
            console.error(error);
            //todo: handle error display
        }
    }

    async function onSaveCLick() {
        setIsLoading(true);

        if (contentDefinitionMode == 'editor') {
            const errorMsg = validateTemplateInputs(templateTitle, templateState, templateCompanies, templateContents, templateVariables);

            if (errorMsg && errorMsg.length > 0) {
                setErrorMessage(errorMsg);
                onOpen();
                setIsLoading(false);
                return;
            }
        }

        try {
            await doCreateTemplate();
        } catch (e) {
            if (e instanceof Error) {
                setErrorMessage(e.message);
                onOpen();
            }
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <MainSection variant="form">
            <Create title="Create Template" isLoading={isLoading} saveButtonProps={{onClick: () => onSaveCLick()}}>
                <TemplateAccordian 
                    setIsLoading={setIsLoading}
                    setTitle={titleChange}
                    setStates={statesChange}
                    setCompanies={companiesChange}
                    setVariables={variablesChange}
                    setCotnent={contentChange}
                    settingsDataRef={settingsDataRef}
                    contentDefinitionMode={contentDefinitionMode}
                    dataRef={dataRef}
                />
            </Create>
            <AlertDialog
              isOpen={isOpen}
              leastDestructiveRef={okRef as any}
              onClose={onClose}
            >
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    Required Content
                  </AlertDialogHeader>
      
                  <AlertDialogBody>
                  {errorMessage}
                  </AlertDialogBody>
      
                  <AlertDialogFooter>
                    <Button ref={okRef as any} onClick={onClose}>
                      OK
                    </Button>
                    
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
        </MainSection>
    );
};